import { Link } from "react-router-dom";
import { Home as HomeIcon, ArrowLeft } from "lucide-react";
import Seo from "../components/Seo";
import { useI18n } from "../i18n/LanguageProvider";
import { pagePath } from "../config/pages";

export default function NotFound() {
  const { t, lang, p } = useI18n();
  return (
    <>
      <Seo
        title={`${t.common.notFoundTitle} | Dentel Vietnam`}
        description={t.common.notFoundBody}
        path="/404"
        lang={lang}
        noindex
      />
      <section className="container-dv flex min-h-[60vh] flex-col items-center justify-center py-20 text-center">
        <p className="font-serif text-7xl text-turquoise sm:text-8xl">404</p>
        <h1 className="mt-4 text-3xl text-navy sm:text-4xl">{t.common.notFoundTitle}</h1>
        <p className="mt-4 max-w-md text-navy/65 leading-relaxed">{t.common.notFoundBody}</p>
        <Link
          to={pagePath("home", lang)}
          data-testid="notfound-home-btn"
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-dental px-7 py-4 text-base font-semibold text-white hover:bg-dental-dark transition-colors"
        >
          <ArrowLeft className="h-5 w-5" />
          {t.common.backHome}
        </Link>
      </section>
    </>
  );
}
